(() => {
  'use strict';
  // Transit ranges checked against Mondial Relay's French FAQ on 26 October 2026.
  // Other services deliberately have no receipt date until verified.
  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const formatDate = date => new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
  const key = date => date.toISOString().slice(0, 10);
  const holidays = (year, country) => {
    const fixed = country === 'BE' ? ['01-01','05-01','07-21','08-15','11-01','11-11','12-25'] : ['01-01','05-01','05-08','07-14','08-15','11-01','11-11','12-25'];
    const days = new Set(fixed.map(value => `${year}-${value}`));
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    const month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    [1,39,50].forEach(offset => days.add(key(new Date(Date.UTC(year, month-1, day+offset)))));
    return days;
  };
  const workingDate = (start, count, country = 'FR') => {
    const date = new Date(start);
    let remaining = count;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate()+1);
      if (date.getUTCDay() === 0 || date.getUTCDay() === 6) continue;
      if (holidays(date.getUTCFullYear(),'FR').has(key(date))) continue;
      if (country === 'BE' && holidays(date.getUTCFullYear(),'BE').has(key(date))) continue;
      remaining--;
    }
    return date;
  };
  const todayInParis = () => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en', { timeZone:'Europe/Paris', year:'numeric',month:'2-digit',day:'2-digit' }).formatToParts(new Date()).filter(p=>p.type!=='literal').map(p=>[p.type,p.value]));
    return new Date(`${parts.year}-${parts.month}-${parts.day}T12:00:00Z`);
  };
  const init = widget => {
    if (widget.dataset.ready) return;
    widget.dataset.ready='true';
    const config=JSON.parse(widget.querySelector('[data-sbc-delivery-config]').textContent);
    const country=widget.querySelector('[data-sbc-delivery-country]');
    const method=widget.querySelector('[data-sbc-delivery-method]');
    const arrival=widget.querySelector('[data-sbc-delivery-arrival]');
    const summary=widget.querySelector('[data-sbc-delivery-summary]');
    const text=(name,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replaceAll(`[${k}]`,String(v)),config.text[name]);
    let generation=0;
    const render=async()=>{
      const current=++generation;
      const api=window.SbcEstimationLivraison;
      if (!api) return;
      const catalogue=await api.catalogue();
      if(current!==generation || !widget.isConnected)return;
      if (!catalogue.size) {arrival.textContent=text('service_unavailable');summary.textContent='';return;}
      if(!country.dataset.ready){
        country.replaceChildren(...Array.from(catalogue,([code,entry])=>new Option(entry.name,code)).sort((a,b)=>a.text.localeCompare(b.text,'fr')));
        country.value=catalogue.has(widget.dataset.country)?widget.dataset.country:'FR';
        country.dataset.ready='true';
      }
      const entry=catalogue.get(country.value);
      const rates=api.estimation(entry,Number(widget.dataset.weight),Number(widget.dataset.total),widget.dataset.currency,country.value);
      const old=method.value;
      method.replaceChildren(...rates.map(rate=>new Option(rate.label,rate.key)));
      method.disabled=!rates.length;
      if(rates.some(rate=>rate.key===old))method.value=old;
      else if(rates.some(rate=>rate.key==='relay'))method.value='relay';
      const selected=rates.find(rate=>rate.key===method.value);
      const range=config.transit[`${country.value}:${method.value}`];
      const prep=[Math.min(...config.prep),Math.max(...config.prep)];
      const now=todayInParis();
      let first=workingDate(now,prep[0]),last=workingDate(now,prep[1]);
      const basis=widget.querySelector('[data-sbc-delivery-basis]');
      if(selected && range){
        first=workingDate(first,Math.min(...range),country.value);last=workingDate(last,Math.max(...range),country.value);
        arrival.textContent=text('arrival',{min:formatDate(first),max:formatDate(last)});
        basis.textContent=text('basis',{prepMin:prep[0],prepMax:prep[1],min:Math.min(...range),max:Math.max(...range)});
        summary.textContent=arrival.textContent+' · '+entry.name;
      }else{
        arrival.textContent=text('dispatch',{min:formatDate(first),max:formatDate(last)});
        basis.textContent=text('no_transit');
        summary.textContent=arrival.textContent+' · '+entry.name;
      }
      widget.querySelector('[data-sbc-delivery-fee]').textContent=selected?(selected.cents===0?text('free'):text('fee',{amount:money(selected.cents)})):text('no_rates');
      const free=entry?.free;
      const promotion=selected?.cents===0 && api.promotionActive?.(country.value)===true && selected?.key===free?.key;
      widget.querySelector('[data-sbc-delivery-free]').textContent=promotion?text('free_promo'):free?.key===selected?.key?text('free_from',{amount:money(free.threshold)}):'';
      widget.querySelector('[data-sbc-relay-note]').hidden=!(method.value==='relay' && ['FR','BE'].includes(country.value));
    };
    country.addEventListener('change',()=>{method.value='';render();});
    method.addEventListener('change',render);
    widget.addEventListener('sbc:delivery-variant',render);
    widget.addEventListener('toggle',()=>{if(widget.open)render();});
    render();
  };
  const boot=()=>document.querySelectorAll('[data-sbc-product-delivery]').forEach(init);
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
  if(document.readyState!=='loading')boot();
})();
